export const MATCH_SHEET_COLUMN_OPTIONS = [
  { key: "present", locked: false },
  { key: "shirt_number", locked: false },
  { key: "player", locked: true },
  { key: "document_number", locked: false },
  { key: "member_number", locked: false },
  { key: "estado", locked: false },
  { key: "goals", locked: false },
  { key: "yellow", locked: false },
  { key: "red", locked: false },
  { key: "blue", locked: false },
  { key: "signature", locked: false },
];

export const MATCH_SHEET_COLUMN_DEFAULTS = {
  present: true,
  shirt_number: true,
  player: true,
  document_number: false,
  member_number: false,
  estado: true,
  goals: true,
  yellow: true,
  red: true,
  blue: true,
  signature: true,
};

export const matchSheetColumnsFromSettings = (settings) => ({
  ...MATCH_SHEET_COLUMN_DEFAULTS,
  ...(settings?.match_sheet?.columns || {}),
  player: true,
});
